// extracted by mini-css-extract-plugin
export var bright = "social-list-module--bright--7b581";
export var dark = "social-list-module--dark--58828";
export var facebook = "social-list-module--facebook--eed5f";
export var findUsAlso = "social-list-module--findUsAlso--f5766";
export var headerBox = "social-list-module--header-box--c1a40";
export var icons = "social-list-module--icons--4df38";
export var instagram = "social-list-module--instagram--e563f";
export var link = "social-list-module--link--02a27";
export var twitter = "social-list-module--twitter--333fc";